import { render, staticRenderFns } from "./panorama-summary-table.vue?vue&type=template&id=b809f2f8&scoped=true"
import script from "./panorama-summary-table.vue?vue&type=script&lang=js"
export * from "./panorama-summary-table.vue?vue&type=script&lang=js"
import style0 from "./panorama-summary-table.vue?vue&type=style&index=0&id=b809f2f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b809f2f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b809f2f8')) {
      api.createRecord('b809f2f8', component.options)
    } else {
      api.reload('b809f2f8', component.options)
    }
    module.hot.accept("./panorama-summary-table.vue?vue&type=template&id=b809f2f8&scoped=true", function () {
      api.rerender('b809f2f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/panorama/components/panorama-summary-table.vue"
export default component.exports